import React, {useState} from 'react';
import PropTypes from "prop-types";
import './menu.scss';

export default function Menu(props) {

  const [isOpen, setOpen] = useState(false);

  const open = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const close = (e) => {
    e.stopPropagation();
    setOpen(false);
  };

  return (
    <div className={`aps__menu align-${props.align} ${isOpen ? 'is-open' : ''}`}>
      <div className={`aps__menu-open`} onClick={open}>
        {props.open
          ? props.open
          : <div className={`aps__open-button`}></div>
        }
      </div>
      <div className={`aps__menu-overlay`} onClick={close}></div>
      <div className={`aps__menu-links`}>
        <div className={`aps__menu-close`}>
          <div className={`aps__close-button`} onClick={close}></div>
        </div>
        {props.children}
      </div>
    </div>
  );
};

Menu.propTypes = {
  links: PropTypes.array,
  open: PropTypes.array,
  align: PropTypes.string,
};

Menu.defaultProps = {
  align: 'left',
};
